import React from "react";
import { Account } from "../models/Account";

export type DashError = string | {error: string, account?: Account}

function translateError(error:DashError):string{
    if(typeof error == 'string')
        return error;
    switch(error.error){
        case 'no-data': return "Não há dados para este mês ainda."
        default: return 'Erro ao carregar dados!'
    }


}

export function DashErrorView({error}:{error:DashError}){
    return <div className="container my-4">
        {translateError(error)}
    </div>
}